import React from 'react';
import './SurveyQuestion.css';
import PropTypes from 'prop-types';
import RadioButton from 'components/shared/radio-button/RadioButton';
import roundFullPng from 'images/round-full.png';
import closeBlueSvg from 'images/close-blue.svg';

export default function SurveyQuestion(props) {
  return (
    <div className="survey-question">
      <div className="question-title">{props.title}</div>
      {props.edit ? (
        <RadioButton
          className="question-radio"
          options={[
            {
              value: 1,
              label: 'Yes',
            },
            {
              value: 0,
              label: 'No',
            },
          ]}
          value={props.value !== null ? (props.value ? 1 : 0) : null}
          onChange={(value) => props.onChange(value === 1)}
        />
      ) : props.value === null ? (
        <div className="img-container">
          <span>N/A</span>
        </div>
      ) : props.value ? (
        <div className="img-container">
          <img src={roundFullPng} alt="with-value" />
          <span>Yes</span>
        </div>
      ) : (
        <div className="img-container">
          <img src={closeBlueSvg} alt="with-value" />
          <span>No</span>
        </div>
      )}
    </div>
  );
}

SurveyQuestion.propTypes = {
  edit: PropTypes.bool,
  title: PropTypes.string.isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

SurveyQuestion.defaultProps = {
  edit: false,
  value: null,
};



// WEBPACK FOOTER //
// ./src/components/admin/surveys/SurveyQuestion.js